export const phrases = {
  unassign_from_album: "Czy naprawdę chcesz usunąć wybrane zdjęcia z albumu?",
  remove_media_from_album: "Usuń z albumu",
  assign_to_which_album: "Do którego albumu chcesz dodać wybrane zdjęcia?",
  rename_album_title: "Możesz edytować swój album tutaj",
  name_of_album: "Jak będzie się nazywał twój nowy album?",
  create_album: "Nowy album",
  assign_media_to_album: "Dodaj do albumu",
  your_party: "Twoja impreza.",
  all_pictures: "Wszystkie zdjęcia.",
  forgot_password: "Zapomniałeś hasła?",
  no_account_yet: "Nie masz jeszcze konta? Zarejestruj się teraz.",
  send_your_event: "Zaproś swoich gości",
  scan_here: "Zeskanuj tutaj",
  show_more_replies: "Zobacz więcej odpowiedzi",
  shared_image_text: "Spójrz na zdjęcie zrobione podczas wydarzenia z https://www.everlense.de",
  image_not_available_anymore: "Ten obraz nie jest już dostępny",
  invite_whatsapp: "Naprawdę nie mogę się doczekać nadchodzącego wydarzenia 🥳. Aby nasz wspólny czas był niezapomniany dzięki wspaniałym zdjęciom, zapraszam Cię do skorzystania z everlense. Po prostu kliknij na link i wpisz swoje imię na listę gości. Rób piękne zdjęcia i dziel się nimi z innymi gośćmi. Do zobaczenia wkrótce! ",
  add_images: "Dodaj obrazy",
  capture_photo: "Zrób zdjęcie",
  enter_your_name: "Wpisz swoje imię i nazwisko",
  your_photo_app_for_weddings: "Twoja aplikacja fotograficzna na wesela",
  invite_guests: "Zaproś gości",
  delete_demo_data: "Usuń dane demonstracyjne",
  event_description_placeholder: "Co jeszcze chcesz powiedzieć swoim gościom? Przejdź do ustawień, aby dostosować opis.",
  start_slideshow: "Rozpocznij pokaz slajdów tutaj",
  slideshow_steps_1: "Przejdź do swojego urządzenia",
  slideshow_steps_2: "i wprowadź następujące dane",
  slideshow_steps_3: "10-cyfrowy kod",
  slideshow_steps_4: "w.",
  print_tasks: "Zadania drukowania",
  edit_tasks: "Zarządzaj zadaniami",
  challenge_tips_and_tricks_1: "Wskazówki i porady dotyczące",
  challenge_tips_and_tricks_2: "Twoje idealne wyzwanie",
  challenge_tips_and_tricks_content_1: "Wydrukuj szablon na grubym papierze.",
  challenge_tips_and_tricks_content_2: "Rozdaj zadania na każde miejsce przed imprezą.",
  challenge_tips_and_tricks_content_3: "Poinformuj jak najwięcej osób o wyzwaniu fotograficznym.",
  challenge_tips_and_tricks_content_4: "Użyj pokazu slajdów na żywo, aby wszyscy goście mogli zobaczyć migawki w czasie rzeczywistym.",
  print_tasks_intro: "Powinieneś wyeksponować je na imprezie, aby goście mogli znaleźć zadania wyzwania fotograficznego.",
  print_tasks_title_1: "Karty do wydrukowania (popularne)",
  print_tasks_title_2: "Eksportuj tylko kody QR (i samodzielnie projektuj karty)",
  print_tasks_action_1: "Pobierz pliki PDF",
  print_tasks_action_2: "Pobierz kody QR",
  print_tasks_description_1: "Twoi goście mogą dołączyć do wyzwania fotograficznego za pomocą kodów QR na naszych kartach do druku.",
  print_tasks_description_2: "Pobierz kody QR, aby rozpocząć wyzwanie fotograficzne i użyj ich do zaprojektowania własnych kart. Na każde zadanie przypada jeden kod QR.",
  edit_tasks_title_1: "Wybierz zadania",
  edit_tasks_title_2: "dla Twoich gości",
  really_want_to_delete_task: "Naprawdę usuwasz zadanie?",
  add_task_button: "Dodaj zadanie",
  delete_all_tasks_button: "Usuń wszystko",
  settings_albums: "Ustawienia albumu",
  upload_to_which_album: "Do którego albumu powinny być automatycznie przesyłane zdjęcia Twoich gości?",
  upload_which_albums_are_shown: "Które albumy chcesz, aby zobaczyli Twoi goście?",
  restrict_access_to_album: "Moi goście mają dostęp tylko do wybranego albumu",
  settings_event_name_header: "Jak powinno nazywać się Twoje wydarzenie?",
  settings_event_description_header: "Co jeszcze powinni wiedzieć Twoi goście?",
  settings_event_name_label: "Nazwa wydarzenia",
  settings_event_description_label: "Opis wydarzenia",
  settings_password_title: "Zmień hasło",
  settings_old_password_header: "Stare hasło",
  settings_new_password_header: "Nowe hasło",
  settings_new_password_repeat_header: "Powtórz nowe hasło",
  settings_invite_admin_title: "Dodaj administratorów",
  settings_invite_admin_header: "Adres e-mail nowego administratora",
  send_invite: "Wyślij zaproszenie",
  settings_deactivate_challenge_title: "Dezaktywuj wyzwanie",
  settings_deactivate_challenge_header: "Aktywuj/dezaktywuj wyzwanie",
  settings_delete_data_title: "Usuń konto",
  settings_delete_data_header: "Trwale usuń wszystkie dane",
  delete_event: "Usuń zdarzenie",
  delete_event_toast_content: "Kliknij \"Usuń\", aby trwale zamknąć swoje konto. UWAGA: Wszystkie przesłane obrazy, filmy i dane zostaną nieodwracalnie utracone i nie będą mogły zostać przywrócone, nawet przez zespół everlense.",
  settings_legal: "Kwestie prawne",
  settings_legal_content_1: "Tworząc swoje wydarzenie masz do dyspozycji",
  settings_legal_content_2: "GTC",
  settings_legal_content_3: " i nasz",
  settings_legal_content_4: "Polityka prywatności ",
  settings_legal_content_5: "zaakceptowany. Jeśli chcesz dowiedzieć się więcej o everlense, odwiedź naszą stronę ",
  settings_legal_content_6: "Nadruk.",
  reset_password: "Zresetuj hasło",
  register_phrase: "Potrzebujemy Twojego adresu e-mail, aby sfinalizować konfigurację Twojego wydarzenia.",
  register_phrase_booked: "Rezerwacja się powiodła! Potrzebujemy Twojego adresu e-mail, aby sfinalizować konfigurację wydarzenia.",
  email_address: "Adres e-mail",
  register_legal: "Dołączając, akceptujesz nasze <a class=\"underline\" href=\"https://www.everlense.de/agb\">warunki i</a> <a class=\"underline\" href=\"https://www.everlense.de/datenschutz\">politykę prywatności</a>. Jeśli chcesz dowiedzieć się więcej o everlense, odwiedź naszą <a class=\"underline\" href=\"https://www.everlense.de/impressum\">notę prawną</a>. Rejestrując się, wyrażasz również zgodę na otrzymywanie od nas marketingowych wiadomości e-mail. Możesz odwołać tę zgodę w dowolnym momencie.",
  guest_register_legal: "Dołączając, akceptujesz nasze <a class=\"underline\" href=\"https://www.everlense.de/agb\">warunki i</a> <a class=\"underline\" href=\"https://www.everlense.de/datenschutz\">politykę prywatności</a>. Jeśli chcesz dowiedzieć się więcej o everlense, odwiedź naszą <a class=\"underline\" href=\"https://www.everlense.de/impressum\">notę prawną</a>.",
  install_everlense: "Zainstaluj everlense",
  install_content_1: "Zainstaluj everlense na ekranie głównym, aby nigdy nie zapomnieć o wydarzeniu.",
  install_content_2: "Kliknij",
  install_content_3: "a następnie \"Przejdź do ekranu głównego\".",
  install_content_4: "Później",
  install_content_5: "W porządku!",
  no_images_yet: "Nie przesłano jeszcze żadnych zdjęć. Naciśnij przycisk plusa, aby przesłać zdjęcie.",
  delete_all_tasks_really: "Naprawdę usuwasz wszystkie zadania?",
  your_task: "Twoje zadanie",
  change_colors: "Zmień kolory",
  primary_color: "Kolor podstawowy",
  background_color: "Kolor tła",
  reset: "Reset",
  choose_color: "Wybierz kolor",
  upgrade_package: "Pakiet aktualizacji",
  upgrade_required: "Wymagana aktualizacja",
  current_package: "Aktualny pakiet",
  used_image_count: "{used} obrazów {max} .",
  deleted_image_count: "{not_deleted} obecnie w Twojej galerii, {deleted} usunięte.",
  used_downloads_count: "{used} używany przez {max} do masowego pobierania.",
  most_popular: "Najpopularniejsze",
  price: '{price} Euro',
  max_media: "maks. {count} zdjęć",
  max_guests: "maks. {count} Goście",
  infinite_guests: "Nieograniczona liczba gości",
  storage_duration: "{duration} Miesiące Okres przechowywania",
  max_bulk_downloads: "bezpłatne pobieranie zbiorcze | bezpłatne pobieranie zbiorcze",
  custom_colors: "Poszczególne kolory",
  multiple_admins: "Wielu administratorów",
  whatsapp_support: "Wsparcie Premium WhatsApp",
  go_to_checkout: "Do kasy",
  start_setup: "Rozpocznij konfigurację",
  upgrade_toast_content: "Aby móc korzystać z tej funkcji, musisz zaktualizować swój pakiet everlense. Zapoznaj się z różnymi opcjami. ",
  no_thank_you: "Nie, dziękuję.",
  i_want_to_know_more: "Dowiedz się więcej",
  demo_event_title: "Lisa i Jan",
  how_do_you_want_to_reedem: "Jak chcesz zrealizować swoją przesyłkę?",
  currently_logged_in_event: "Jesteś obecnie zalogowany do wydarzenia: {name} Czy chcesz zastosować swój zakup do tego wydarzenia?",
  choose_event: "Na które wydarzenie chcesz przeznaczyć swój zakup?",
  use_for_current_event: "bieżące wydarzenie",
  use_for_existing_event: "istniejące zdarzenie",
  use_for_new_event: "nowe wydarzenie",
  settings_event_date_header: "Kiedy odbywa się Twoje wydarzenie?",
  settings_event_date_label: "Data wydarzenia",
  sort: "Sortuj",
  time_of_recording: "Czas nagrywania",
  time_of_upload: "Czas przesyłania",
  lets_setup_event: "Zorganizujmy razem Twoje wydarzenie",
  we_will_help_you_setup: "Pomożemy Ci skonfigurować wydarzenie everlense w zaledwie 2 minuty. Masz na to ochotę?",
  what_is_the_name: "Jaka powinna być nazwa Twojego wydarzenia?",
  cancel_setup: "Anuluj konfigurację",
  enter_event_name_here: "Wpisz tutaj nazwę wydarzenia",
  when_does_event_take_place: "Kiedy odbywa się Twoje wydarzenie?",
  enter_event_date_here: "Wpisz tutaj datę wydarzenia",
  nice_please_upload_photo: "Bardzo fajnie. Prześlij teraz zdjęcie z wydarzenia, aby jeszcze bardziej je spersonalizować",
  select_photo: "Wybierz zdjęcie",
  what_do_you_want_to_describe: "Wow! Coś jeszcze chciałbyś powiedzieć swoim gościom?",
  enter_description_here: "Wprowadź opis tutaj",
  finish_setup: "Zakończ konfigurację",
  successfull_save: "Pomyślnie zapisane",
  successfull_deletion: "Usunięto pomyślnie",
  copied_link: "Link skopiowany",
  booking_successfull: "Rezerwacja powiodła się",
  completed_setup: "Instalacja zakończona",
  sent_invite: "Zaproszenie wysłane",
  initiated_payout: "Utworzona wypłata",
  sent_email: "E-mail wysłany",
  max_ten_images: "Maksymalnie 10 obrazów jednocześnie.",
  reached_download_limit: "Osiągnięto limit pobierania wydarzenia.",
  reached_mass_download_limit: "Osiągnięto maksymalną liczbę pobrań masowych.",
  no_images_were_uploaded: "Nie przesłano jeszcze żadnych zdjęć.",
  booking_failed: "Rezerwacja nie powiodła się.",
  package_already_retrieved: "Pakiet został już zrealizowany",
  download_all_pictures: "Pobierz wszystkie obrazy",
  notice: "Wskazówka",
  in_your_package: "W Twojej paczce",
  bulk_download_modal_2: "wszystkich zdjęć jednocześnie. Jeśli teraz klikniesz \"Pobierz\", zużyjesz",
  bulk_download_modal_3: "jeden z nich",
  bulk_download_modal_4: "to",
  bulk_download_modal_5: "pobierz",
  bulk_download_modal_6: "Wykorzystałeś wszystkie pliki do pobrania zbiorczego w swoim pakiecie. Zarezerwuj uaktualnienie, aby pobrać wszystkie obrazy.",
  bulk_download_modal_7: "Poczekaj. Twoje obrazy są przygotowywane do pobrania.",
  donwload_modal_1: '',
  donwload_modal_2: "naprawdę pobierasz?",
  delete_modal_1: '',
  delete_modal_2: "naprawdę usunąć?",
  download_preparation: "Twoje pliki do pobrania są przygotowywane. Najpóźniej za 15 minut otrzymasz wiadomość e-mail z osobistym linkiem do pobrania.",
  save_pictures: "Zapisz obrazy",
  delete_pictures: "Usuń obrazy",
  upload_in_progress: "Prześlij uruchomione",
  change_language: "Zmień język",
  change_language_info: "Opracowaliśmy everlense tak, aby język automatycznie dostosowywał się do języka przeglądarki na urządzeniach Twoich gości. Tak więc, jeśli masz międzynarodowych gości na swoim weselu, nie stanowi to problemu, a galeria zdjęć jest zawsze zrozumiała dla wszystkich.",
  multiple_languages_1: "Wielojęzyczność",
  multiple_languages_2: "(Angielski i niemiecki)",
  okay: "W porządku!",
  download_pictures: "Pobierz obrazy",
  max_ten_images_go_to_settings: "Możesz pobrać maksymalnie 10 obrazów. Przejdź do ustawień, aby pobrać wszystkie obrazy.",
  your_images_are_ready: "Twoje zdjęcia są gotowe!",
  here_are_your_images: "Oto zdjęcia z Twojego wydarzenia {event}. Bawcie się dobrze!",
  ps_mass_download: "PS: Po prostu pobieraj części jedna po drugiej. Zostanie to policzone jako pobranie zbiorcze.",
  download_here: "Pobierz tutaj",
  download_part: "Pobierz część {part}",
  switch_language: "Zmień język",
  tasks_choose_language: "Jaki język powinny mieć przykładowe zadania?",
  successfull_task_recreation: "Język przykładowych zadań został zmieniony",
  something_went_wrong: "Coś poszło nie tak",
  a_small_present_for_you: "Mały prezent dla Ciebie!",
  present_description: "Chcesz wykorzystać everlense na swoim wydarzeniu? <span class=\"font-medium\">W takim razie mamy dla Ciebie niespodziankę</span>. Wyślemy ją na Twój adres e-mail.",
  your_email_address: "Twój adres e-mail",
  save_discount: "Wysyłanie",
  accept_agb_and_mail: "Zgadzam się z regulaminem <a href=\"https://www.everlense.de/agb\" class=\"font-medium cursor-pointer\">i</a> chcę otrzymywać wiadomości e-mail od everlense.",
  thank_you_for_sending: "W ciągu najbliższych 15 minut wyślemy Ci wiadomość e-mail ze spersonalizowaną niespodzianką.",
  discount_saved: "Niespodzianka zabezpieczona!",
  was_reported: "Gość zgłosił tę stronę {type} .",
  what_shall_happen: "Co powinno się stać z tym {type} ?",
  edit_reporting_description: "Sprawdź stronę {type} i zdecyduj, czy powinna zostać ponownie udostępniona, czy trwale usunięta. W międzyczasie ukryliśmy obraz.",
  how_did_you_get_to_know_us: "Skąd dowiedziałeś się o everlense?",
  please_select: "Wybierz",
  friends_and_family: "Przyjaciele i znajomi",
  seen_at_a_wedding: "Widziany na weselu",
  other: "Różne",
  settings_deactive_challenge_text_download: "Etykietowanie obrazów podczas pobierania",
  your_payment_is_processing: "Twoja płatność jest przetwarzana. Prosimy o chwilę cierpliwości.",
  coupon_code: "Kod kuponu",
  what_discount_code: "Jak powinien nazywać się Twój spersonalizowany kod rabatowy?",
  message_to_everlense_team: "Wiadomość do zespołu everlense",
  select_design: "Wybierz projekt",
  choose_your_flyer_design: "Wybierz projekt karty z kodem QR:",
  choose_your_qr_design: "Wybierz kolor kodu QR:",
  show_qr_code_on_diashow: "Pokaż kod QR w pokazie slajdów na żywo",
  diashow_prioritize_new: "Nadaj priorytet wyświetlaniu nowych obrazów",
  more_settings: "Dalsze ustawienia",
  duration_per_medium: "Czas wyświetlania jednego obrazu",
  album_not_visible_to_guests: "Album musi być widoczny."
};